import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-why-exive-container" }
const _hoisted_2 = { class: "home-why-exive-container-image" }
const _hoisted_3 = { class: "home-why-exive-title-top-container" }
const _hoisted_4 = { class: "home-why-exive-title-container" }
const _hoisted_5 = { class: "home-why-exive-title" }
const _hoisted_6 = { class: "home-why-exive-subtitle" }
const _hoisted_7 = { class: "home-why-exive-proses" }
const _hoisted_8 = { class: "home-why-exive-proses-pros" }
const _hoisted_9 = { class: "home-why-exive-proses-pros-title-container" }
const _hoisted_10 = { class: "home-why-exive-proses-pros-title" }
const _hoisted_11 = { class: "home-why-exive-proses-pros-description" }
const _hoisted_12 = { class: "home-why-exive-proses-pros" }
const _hoisted_13 = { class: "home-why-exive-proses-pros-title-container" }
const _hoisted_14 = { class: "home-why-exive-proses-pros-title" }
const _hoisted_15 = { class: "home-why-exive-proses-pros-description" }
const _hoisted_16 = { class: "home-why-exive-proses-pros" }
const _hoisted_17 = { class: "home-why-exive-proses-pros-title-container" }
const _hoisted_18 = { class: "home-why-exive-proses-pros-title" }
const _hoisted_19 = { class: "home-why-exive-proses-pros-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("home.why-exive.question-title")), 1)
        ]),
        _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("home.why-exive.question-subtitle")), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t("home.why-exive.answer-title-time")), 1),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "home-why-exive-proses-pros-title_underline" }, null, -1))
          ]),
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("home.why-exive.answer-title-time-description")), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.$t("home.why-exive.answer-title-security")), 1),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "home-why-exive-proses-pros-title_underline" }, null, -1))
          ]),
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("home.why-exive.answer-title-security-description")), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.$t("home.why-exive.answer-title-money")), 1),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "home-why-exive-proses-pros-title_underline" }, null, -1))
          ]),
          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("home.why-exive.answer-title-money-description")), 1)
        ])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "home-why-exive-image" }, null, -1))
    ])
  ]))
}